import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const industries = [
  { key: 'travel', emoji: '🚗' },
  { key: 'restaurant', emoji: '🏨' },
  { key: 'medical', emoji: '💉' },
  { key: 'education', emoji: '🏫' },
  { key: 'ecommerce', emoji: '🛒' },
  { key: 'realestate', emoji: '🏠' },
];

export const OmniIndustry = () => {
  const { t } = useTranslation('landing');

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        backgroundColor: '#f8fafc',
        py: '100px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -60,
          left: 0,
          right: 0,
          height: 60,
          backgroundColor: '#f8fafc',
          clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
        },
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, md: 4 } }}>
        {/* Section label */}
        <Typography
          className="omni-reveal"
          sx={{
            textAlign: 'center',
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: 2,
            textTransform: 'uppercase',
            color: '#3664D1',
            mb: 1.5,
          }}
        >
          {t('industries.label')}
        </Typography>

        {/* Section title */}
        <Typography
          variant="h3"
          className="omni-reveal omni-reveal-delay-1"
          sx={{
            textAlign: 'center',
            fontWeight: 800,
            fontSize: { xs: 28, md: 36 },
            color: '#0f1729',
            mb: 1.5,
          }}
        >
          {t('industries.headline')}
        </Typography>

        {/* Section subtitle */}
        <Typography
          className="omni-reveal omni-reveal-delay-2"
          sx={{
            textAlign: 'center',
            fontSize: { xs: 16, md: 18 },
            color: '#6b7280',
            mb: 6,
            maxWidth: 600,
            mx: 'auto',
          }}
        >
          {t('industries.subheadline')}
        </Typography>

        {/* Grid of 6 cards */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: 3,
          }}
        >
          {industries.map((industry, index) => {
            const delayClass =
              index % 3 === 0
                ? ''
                : index % 3 === 1
                ? 'omni-reveal-delay-1'
                : 'omni-reveal-delay-2';

            return (
              <Box
                key={industry.key}
                className={`omni-industry-card omni-reveal ${delayClass}`}
              >
                {/* Emoji icon */}
                <Typography sx={{ fontSize: 40, mb: 2, lineHeight: 1 }}>
                  {industry.emoji}
                </Typography>

                {/* Title */}
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 18,
                    color: '#0f1729',
                    mb: 1,
                  }}
                >
                  {t(`industries.${industry.key}.title`)}
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    fontSize: 15,
                    color: '#6b7280',
                    lineHeight: 1.6,
                  }}
                >
                  {t(`industries.${industry.key}.desc`)}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
